import type { GA4EventParameters } from "@utils/google-analytics-4.type";
import React from "react";

export interface LeadFormStepContainerContextType {
	onStep: (step: string, data: Record<string, any>) => void;
	onChange?: (step: string, data: Record<string, any>) => void;

	stepNumber: number;
	previousSteps: string[];
	activeStep: string;
	activeAnim: string;

	ga4Event: GA4EventParameters;

	bottomLogo: boolean;
	colorScheme: "dark" | "light";
}

export const LeadFormStepContainerContext = React.createContext<LeadFormStepContainerContextType>({
	onStep: (_step: string, _data: Record<string, any>) => undefined,
	onChange: (_step: string, _data: Record<string, any>) => undefined,

	stepNumber: 0,
	previousSteps: [],
	activeStep: undefined,
	activeAnim: "",

	ga4Event: undefined,

	bottomLogo: true,
	colorScheme: "dark",
});
